<div class="dialog-overlay">
  <div class="invitation-container">
    <!-- Header with red background -->
    <div class="invitation-header" [ngStyle]="headerStyle">
      <button class="close-button" (click)="onClose()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>

      <div class="header-content">
        <img
          *ngIf="data?.template?.header?.logoUrl"
          [src]="data.template.header?.logoUrl"
          alt="Company Logo"
          class="company-logo"
        />

        <div class="header-text">
          <h2 class="header-title">
            {{ getLocalizedText(data.template.header?.title) }}
          </h2>
          <p class="header-subtitle">
            {{ getLocalizedText(data.template.header?.subtitle) }}
          </p>
        </div>
      </div>
    </div>

    <!-- Body content -->
    <div class="invitation-body">
      <h3 class="section-title">
        {{ getLocalizedText(data.template.body?.sectionTitle) }}
      </h3>

      <!-- Body paragraphs (if present, shown before bullets) -->
      <div class="body-paragraphs" *ngIf="data.template.body?.paragraphs">
        <p
          *ngFor="let paragraph of data.template.body?.paragraphs"
          class="body-paragraph"
        >
          {{ getLocalizedText(paragraph?.text) }}
        </p>
      </div>

      <!-- Bullet points with checkmarks -->
      <div class="benefits-list" *ngIf="data.template.body?.bullets">
        <div
          *ngFor="let bullet of data.template.body?.bullets"
          class="benefit-item"
        >
          <mat-icon class="check-icon">check</mat-icon>
          <span>{{ getLocalizedText(bullet?.text) }}</span>
        </div>
      </div>

      <!-- Action buttons -->
      <div class="action-buttons">
        <button
          mat-raised-button
          class="primary-button"
          [ngStyle]="{'background': 'linear-gradient(135deg, ' + getDarkerShade(corporateColor) + ', ' + corporateColor + ')', 'border-color': corporateColor}"
          (click)="onAction('accept')"
        >
          <mat-icon>check</mat-icon>
          {{ 'STANDALONE-COMPONENTS.B2B-INVITATION-DIALOG.BUTTONS.ACCEPT' | translate }}
        </button>

        <button
          mat-stroked-button
          class="secondary-button"
          [ngStyle]="{'border-color': corporateColor, 'color': corporateColor}"
          (click)="onAction('reject')"
        >
          <mat-icon>close</mat-icon>
          {{ 'STANDALONE-COMPONENTS.B2B-INVITATION-DIALOG.BUTTONS.DECLINE' | translate }}
        </button>

        <button
          mat-stroked-button
          class="tertiary-button"
          [ngStyle]="{'border-color': getLighterShade(corporateColor), 'color': getLighterShade(corporateColor)}"
          (click)="onAction('continue')"
        >
          {{ 'STANDALONE-COMPONENTS.B2B-INVITATION-DIALOG.BUTTONS.CONTINUE' | translate }}
        </button>
      </div>

      <!-- Footer with expiration -->
      <div class="invitation-footer" *ngIf="hasExpiration">
        <p class="expiration-text">
          {{ 'STANDALONE-COMPONENTS.B2B-INVITATION-DIALOG.FOOTER.EXPIRES_IN_DAYS' | translate: { daysLeft: daysLeft } }}
        </p>
      </div>
    </div>
  </div>
</div>
